module.exports = __webpack_public_path__ + "static/media/29COICT8.634cee03.jpg";